var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as fontkit from 'fontkit';
import { Buffer } from 'buffer';
import { DEFAULT_FONT_VALUE, DEFAULT_FONT_NAME, DEFAULT_FONT_SIZE, DEFAULT_CHARACTER_SPACING, DEFAULT_TOLERANCE, DEFAULT_FONT_SIZE_ADJUSTMENT, DEFAULT_PT_TO_MM_RATIO } from './constants';
import { b64toUint8Array } from ".";
const widthOfTextAtSize = (input, fontKitFont, fontSize) => {
    const { glyphs } = fontKitFont.layout(input);
    const scale = 1000 / fontKitFont.unitsPerEm;
    return glyphs.reduce((totalWidth, glyph) => totalWidth + glyph.advanceWidth * scale, 0) * (fontSize / 1000);
};
const calculateCharacterSpacing = (textContent, textCharacterSpacing) => {
    const numberOfCharacters = textContent.length;
    return (numberOfCharacters - 1) * textCharacterSpacing;
};
const calculateTextWidthInMm = (textContent, textWidth, textCharacterSpacing) => (textWidth + calculateCharacterSpacing(textContent, textCharacterSpacing)) * DEFAULT_PT_TO_MM_RATIO;
const getLongestLine = (textContentRows, fontKitFont, fontSize, characterSpacingCount) => {
    let longestLine = '';
    let maxLineWidth = 0;
    textContentRows.forEach((line) => {
        const textWidth = widthOfTextAtSize(line, fontKitFont, fontSize);
        const lineWidth = calculateTextWidthInMm(line, textWidth, characterSpacingCount);
        if (lineWidth > maxLineWidth) {
            longestLine = line;
            maxLineWidth = lineWidth;
        }
    });
    return longestLine;
};
const fontKitFontCache = {};
const createFontKitFont = (font, fontName = DEFAULT_FONT_NAME) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (fontKitFontCache[fontName]) {
        return fontKitFontCache[fontName];
    }
    let fontData = ((_a = font[fontName]) === null || _a === void 0 ? void 0 : _a.data) || DEFAULT_FONT_VALUE;
    if (typeof fontData === 'string') {
        fontData = fontData.startsWith('http') ? yield fetch(fontData).then((res) => res.arrayBuffer()) : b64toUint8Array(fontData);
    }
    const fontKitFont = fontkit.create(fontData instanceof Buffer ? fontData : Buffer.from(fontData));
    fontKitFontCache[fontName] = fontKitFont;
    return fontKitFont;
});
const getTextContent = (input, fontKitFont, fontSize, characterSpacingCount) => {
    const textContentRows = input.split('\n');
    return textContentRows.length > 1 ? getLongestLine(textContentRows, fontKitFont, fontSize, characterSpacingCount) : input;
};
export const calculateDynamicFontSize = ({ textSchema, font, input }) => __awaiter(void 0, void 0, void 0, function* () {
    const { fontName, fontSize: _fontSize, dynamicFontSize: dynamicFontSizeSetting, characterSpacing, width } = textSchema;
    const fontSize = _fontSize || DEFAULT_FONT_SIZE;
    if (!dynamicFontSizeSetting)
        return fontSize;
    const characterSpacingCount = characterSpacing !== null && characterSpacing !== void 0 ? characterSpacing : DEFAULT_CHARACTER_SPACING;
    const fontKitFont = yield createFontKitFont(font, fontName);
    const textContent = getTextContent(input, fontKitFont, fontSize, characterSpacingCount);
    const textWidth = widthOfTextAtSize(textContent, fontKitFont, fontSize);
    let dynamicFontSize = fontSize;
    let textWidthInMm = calculateTextWidthInMm(textContent, textWidth, characterSpacingCount);
    while (textWidthInMm > width - DEFAULT_TOLERANCE && dynamicFontSize > dynamicFontSizeSetting.min) {
        dynamicFontSize -= DEFAULT_FONT_SIZE_ADJUSTMENT;
        textWidthInMm = calculateTextWidthInMm(textContent, widthOfTextAtSize(textContent, fontKitFont, dynamicFontSize), characterSpacingCount);
    }
    while (textWidthInMm < width - DEFAULT_TOLERANCE && dynamicFontSize < dynamicFontSizeSetting.max) {
        dynamicFontSize += DEFAULT_FONT_SIZE_ADJUSTMENT;
        textWidthInMm = calculateTextWidthInMm(textContent, widthOfTextAtSize(textContent, fontKitFont, dynamicFontSize), characterSpacingCount);
    }
    return dynamicFontSize;
});
//# sourceMappingURL=calculateDynamicFontSize.js.map